const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://offersshopping.com';

export default function DistribuidorSeoJsonLd() {
  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Programa Distribuidor', item: `${SITE_URL}/distribuidor` },
    ],
  };

  const service = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Programa de Distribuidores - Digital Licence Store',
    description: 'Únete a nuestra red de distribuidores de licencias de software originales. Accede a precios mayoristas con descuentos hasta 40%, soporte prioritario 24/7 y panel de control exclusivo.',
    url: `${SITE_URL}/distribuidor`,
    provider: {
      '@type': 'Organization',
      name: 'Digital Licence Store',
      url: SITE_URL,
      telephone: '+79534940353',
      email: 'DigitalLicenceStore@offersshopping.com',
    },
    serviceType: 'Distribución de licencias de software',
    areaServed: {
      '@type': 'Country',
      name: 'Colombia',
    },
    offers: {
      '@type': 'Offer',
      description: 'Descuentos mayoristas hasta 40% en licencias de Windows, Office, Antivirus y VPN',
      availability: 'https://schema.org/InStock',
      url: `${SITE_URL}/distribuidor`,
    },
  };

  const webpage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Programa Distribuidor Licencias Software Colombia - Digital Licence Store',
    description: 'Conviértete en distribuidor de licencias de software originales. Precios mayoristas hasta 40% descuento, soporte 24/7 y panel exclusivo. Únete a más de 500 distribuidores activos.',
    url: `${SITE_URL}/distribuidor`,
    inLanguage: 'es-CO',
    isPartOf: { '@type': 'WebSite', name: 'Digital Licence Store', url: SITE_URL },
    breadcrumb: breadcrumb,
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(service) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpage) }} />
    </>
  );
}
